import { usePageTracking, useSessionTracking } from '@/hooks/useAnalytics';

/**
 * Analytics Page Tracker Component
 *
 * This component handles automatic page view tracking and session management.
 * It should be included once at the app level to track all route changes.
 */
export function AnalyticsPageTracker() {
  // Automatically track page views on route changes
  usePageTracking();

  // Track session duration and visibility changes
  useSessionTracking();

  // This component doesn't render anything
  return null;
}